module.exports = require("jaeger-client/dist/src/samplers/remote_sampler");